"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextStepWhenItsNotLast = void 0;
function getNextStepWhenItsNotLast(options, step) {
    if (options.includes(step)) {
        if (typeof options[options.indexOf(step) + 1] !== "string") {
            if (typeof options[options.indexOf(step) + 1]["1"][0] !== "string") {
                throw new Error("Wizard: the first entry must always be a string");
            }
            return options[options.indexOf(step) + 1]["1"][0];
        }
        return options[options.indexOf(step) + 1];
    }
    for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
        var option = options_1[_i];
        if (typeof option !== "string") {
            var nextStepWhenItsNotLast = getNextStepWhenItsNotLast(Object.values(option), step);
            if (!!nextStepWhenItsNotLast) {
                return nextStepWhenItsNotLast;
            }
        }
    }
    return "";
}
exports.getNextStepWhenItsNotLast = getNextStepWhenItsNotLast;
//# sourceMappingURL=getNextStepWhenItsNotLast.js.map